import axios, { AxiosError } from 'axios';
import { CommonRootState } from '../combineReducers';
import { IRelease } from '../interfaces/release';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

const fetchPrimaryOrganizationReleasesRequest = () =>
  ({
    type: 'FETCH_PRIMARY_ORGANIZATION_RELEASES_REQUEST'
  } as const);

const fetchPrimaryOrganizationReleasesSuccess = (payload: IRelease[]) =>
  ({
    type: 'FETCH_PRIMARY_ORGANIZATION_RELEASES_SUCCESS',
    payload
  } as const);

const fetchPrimaryOrganizationReleasesFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_PRIMARY_ORGANIZATION_RELEASES_FAILURE',
    error
  } as const;
};

const shouldFetchPrimaryOrganizationReleases = (state: CommonRootState) =>
  !state.primaryOrganizationReleases.isFetching;

const fetchPrimaryOrganizationReleases = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchPrimaryOrganizationReleasesRequest());

    const response = await axios.get<IRelease[]>(`/api/v3.0/organizations/${organizationId}/releases`);

    dispatch(fetchPrimaryOrganizationReleasesSuccess(response.data));
  } catch (error) {
    dispatch(fetchPrimaryOrganizationReleasesFailure(error));
  }
};

export const fetchPrimaryOrganizationReleasesIfNeeded = (
  organizationId: string
): ThunkAction<void, CommonRootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchPrimaryOrganizationReleases(getState())) {
    dispatch(fetchPrimaryOrganizationReleases(organizationId));
  }
};

export type Actions =
  | ReturnType<typeof fetchPrimaryOrganizationReleasesRequest>
  | ReturnType<typeof fetchPrimaryOrganizationReleasesSuccess>
  | ReturnType<typeof fetchPrimaryOrganizationReleasesFailure>;
